export const employees: Record<string, string> = {
  // Employees — meta
  'employees.addEmployee': 'Thêm nhân viên',
  'employees.editEmployee': 'Sửa nhân sự',
  'employees.employees': 'nhân viên',
  'employees.emptyHint': 'Không tìm thấy nhân viên. Chạy ETL để nhập dữ liệu.',
  'employees.loadError': 'Tải thất bại',
  // Employees — table columns
  'employees.col.code': 'Mã',
  'employees.col.name': 'Tên',
  'employees.col.email': 'Email',
  'employees.col.dept': 'Phòng ban',
  'employees.col.jobTitle': 'Chức danh',
  'employees.col.jobLevel': 'Cấp bậc',
  'employees.col.empType': 'Loại',
  'employees.col.status': 'Trạng thái',
  'employees.col.startDate': 'Ngày bắt đầu',
  // Employees — field labels
  'employees.employeeCode': 'Mã nhân viên',
  'employees.fullName': 'Họ và tên',
  'employees.email': 'Email',
  'employees.department': 'Phòng ban',
  'employees.jobTitle': 'Chức danh',
  'employees.jobLevel': 'Cấp bậc',
  'employees.employmentType': 'Loại hình',
  'employees.employmentStatus': 'Trạng thái',
  'employees.startDate': 'Ngày bắt đầu',
  'employees.endDate': 'Ngày kết thúc',
  'employees.officialDate': 'Ngày chính thức',
  'employees.phone': 'Điện thoại',
  'employees.address': 'Địa chỉ',
  'employees.birthDate': 'Ngày sinh',
  'employees.cccd': 'Số CCCD',
  'employees.cccdDate': 'Ngày cấp CCCD',
  'employees.cccdIssuePlace': 'Nơi cấp CCCD',
  'employees.cccdPhotoLink': 'Link ảnh CCCD',
  'employees.bankAccount': 'Số tài khoản',
  'employees.bankName': 'Ngân hàng',
  'employees.insuranceId': 'Mã bảo hiểm',
  'employees.insuranceDate': 'Ngày bảo hiểm',
  'employees.bhxhMonth': 'Tháng đóng BHXH',
  'employees.workLocation': 'Địa điểm làm việc',
  'employees.contractType': 'Loại hợp đồng',
  'employees.contractEndDate': 'Ngày kết thúc HĐ',
  'employees.contractEndDateHint': 'Nhập dd/mm/yyyy, hoặc "Không xác định thời hạn". Để trống nếu chưa biết.',
  'employees.contractEndDateReads': 'Hệ thống đọc là: ngày {d} tháng {m} năm {y}',
  'employees.contractEndDateInvalid': 'Ngày kết thúc HĐ phải là dd/mm/yyyy hoặc "Không xác định thời hạn"',
  'employees.contracts.hint': 'HR Lead nhận thông báo khi hợp đồng còn 15, 10 và 5 ngày. Chỉ báo được cho người có ngày kết thúc HĐ dạng dd/mm/yyyy — những người ở danh sách thứ hai sẽ không bao giờ được báo cho tới khi nhập ngày (hoặc chọn "Không xác định thời hạn").',
  'employees.contracts.expiring': 'Sắp hết hạn (trong 15 ngày) hoặc đã quá hạn',
  'employees.contracts.expiringEmpty': 'Không có hợp đồng nào hết hạn trong 15 ngày tới.',
  'employees.contracts.unreadable': 'Chưa có ngày kết thúc HĐ đọc được',
  'employees.contracts.unreadableEmpty': 'Mọi nhân sự đang làm đều đã có ngày kết thúc HĐ hoặc ghi "Không xác định thời hạn".',
  'employees.contracts.notEntered': 'Chưa nhập',
  'employees.contracts.timeLeft': 'Thời gian còn lại',
  'employees.contracts.daysLeft': 'Còn {n} ngày',
  'employees.contracts.today': 'Hết hạn hôm nay',
  'employees.contracts.overdue': 'Quá hạn {n} ngày',
  'employees.seniority': 'Thâm niên (năm)',
  'employees.oldAddress': 'Địa chỉ thường trú cũ',
  'employees.notes': 'Ghi chú',
  'employees.gender': 'Giới tính',
  'employees.genderMale': 'Nam',
  'employees.genderFemale': 'Nữ',
  'employees.genderUnknown': 'Chưa rõ',
  // Employees — section headers
  'employees.section.directory': 'Thông tin công việc',
  'employees.section.personal': 'Thông tin cá nhân',
  'employees.section.finance': 'Tài chính',
  'employees.section.hr': 'Nhân sự',
  // Employees — form section headers
  'employees.form.basic': 'Thông tin cơ bản',
  'employees.form.hr': 'Nhân sự',
  'employees.form.personal': 'Cá nhân (PII)',
  'employees.form.finance': 'Tài chính (PII)',
  'employees.form.notes': 'Ghi chú',
  // Overview tab
  'overview.headcount': 'Tổng số nhân viên',
  'overview.byDepartment': 'Theo phòng ban',
  'overview.byStatus': 'Theo trạng thái',
  'overview.byType': 'Theo loại hình',
  'overview.byLevel': 'Theo cấp bậc',
  // Salary tab
  'salary.amount': 'Số tiền (VNĐ)',
  'salary.row': 'Loại',
  'salary.net': 'Lương NET',
  'salary.gross': 'Lương Gross',
  'salary.workdays': 'Ngày công',
  'salary.status': 'Trạng thái',
  'salary.noData': 'Chưa có dữ liệu lương.',
  'salary.total': 'Tổng cộng',
  // Profile
  'profile.tab.personal': 'Cá nhân',
  'profile.apiTokens.title': 'API token',
  'profile.apiTokens.hint': 'Cho script và AI agent: gọi API với Authorization: Bearer <token>. Token hành động như chính bạn, với quyền của bạn, chỉ trong phạm vi đã chọn.',
  'profile.apiTokens.new': 'Token mới',
  'profile.apiTokens.name': 'Tên',
  'profile.apiTokens.namePlaceholder': 'vd: claude-docs',
  'profile.apiTokens.scopes': 'Phạm vi',
  'profile.apiTokens.scope.docs': 'Docs (đọc, tạo, sửa trang)',
  'profile.apiTokens.scope.docsDelete': 'Cho phép xoá trang (không khôi phục)',
  'profile.apiTokens.scope.issues': 'Issues (issue, bình luận, link)',
  'profile.apiTokens.scope.admobRead': 'AdMob theo giờ (chỉ đọc GET /api/ecpm/source-hourly, hạn tối đa 30 ngày)',
  'profile.apiTokens.scope.iapKeys': 'Khoá collector báo cáo Play (cấp, thu hồi key store, bật release agent: cho deploy/iap-collector-key.mjs, hạn tối đa 30 ngày)',
  'profile.apiTokens.expiry': 'Hết hạn sau',
  'profile.apiTokens.days': 'ngày',
  'profile.apiTokens.create': 'Tạo token',
  'profile.apiTokens.secretOnce': 'Sao chép ngay. Token chỉ hiện một lần.',
  'profile.apiTokens.prefix': 'Token',
  'profile.apiTokens.expires': 'Hết hạn',
  'profile.apiTokens.lastUsed': 'Dùng lần cuối',
  'profile.apiTokens.revoke': 'Thu hồi',
  'profile.apiTokens.revokeConfirm': 'Thu hồi token này? Mọi thứ đang dùng nó sẽ dừng ngay.',
  'profile.apiTokens.empty': 'Chưa có token nào.',
  'profile.apiTokens.mcp.title': 'Kết nối AI agent (MCP)',
  'profile.apiTokens.mcp.hint': 'Đặt token vào biến môi trường SYSTEM_API_TOKEN rồi chạy lệnh này trong terminal. Codex / Cursor: cùng URL và header Authorization.',
  'profile.apiTokens.rest.title': 'Gọi số liệu AdMob theo giờ (REST)',
  'profile.apiTokens.rest.hint': 'Đặt token vào biến môi trường SYSTEM_API_TOKEN rồi gọi như dưới (tham số: hours, to, pCode, sourceId, source). Token này chỉ đọc được endpoint này và chỉ bằng GET.',
  'profile.tab.info': 'Thông tin',
  'profile.tab.employment': 'Công việc',
  'profile.tab.salary': 'Lương',
  'profile.tab.documents': 'Giấy tờ & Bảo hiểm',
  'profile.tab.bank': 'Ngân hàng',
  'profile.tab.commission': 'Hoa hồng',
  'profile.tab.employeesCommission': 'Employees Commission',
  'profile.empComm.pickEmployee': 'Chọn nhân viên',
  'profile.empComm.pickEmployeeHint': 'Chọn một nhân viên để xem hoa hồng',
  'profile.empComm.noData': 'Nhân viên này chưa có dữ liệu hoa hồng',
  'profile.myComm.noData': 'Bạn chưa có hoa hồng ở kỳ nào đã chốt',
  'profile.empComm.noneThisMonth': 'Không có hoa hồng trong tháng này',
  'profile.empComm.total': 'Tổng hoa hồng',
  'profile.empComm.commission': 'Hoa hồng',
  'profile.noRecord': 'Không tìm thấy hồ sơ nhân sự liên kết với tài khoản này.',
  // Exam
  // UA Assignment History
  'ua.timestamp': 'Thời gian',
  'ua.product': 'Sản phẩm',
  'ua.from': 'Người cũ',
  'ua.to': 'Người mới',
  'ua.changedBy': 'Người thay đổi',
  'ua.reason': 'Lý do',
  'ua.reassign': 'Đổi UA',
  'ua.reassignTitle': 'Đổi chủ UA',
  'ua.currentOwner': 'Chủ UA hiện tại',
  'ua.newOwner': 'Chủ UA mới',
  'ua.secondaryOwners': 'Người phụ (xem report)',
  'ua.secondaryOwnersHint': 'Người phụ xem được report của app; hoa hồng vẫn tính cho người chính.',
  'ua.noOwner': '— Không có UA —',
  // Dev Permissions
  'devPerms.email': 'Email',
  'devPerms.group': 'Nhóm',
  'devPerms.admin': 'Admin',
  'devPerms.hideCosts': 'Ẩn chi phí',
  'devPerms.yes': 'Có',
  'devPerms.no': 'Không',
  'devPerms.devGroups': 'Nhóm Dev',
  'devPerms.appPermissions': 'Quyền App',
  'devPerms.addEntry': 'Thêm mục',
  'devPerms.addTitle': 'Thêm quyền dev',
  'devPerms.editTitle': 'Sửa quyền dev',
  'devPerms.actions': 'Thao tác',
  'devPerms.deleteConfirm': 'Xoá mục quyền dev này?',
  // App Permissions tab
  'appPerm.product': 'Sản phẩm',
  'appPerm.assignedDevs': 'Dev được phân quyền',
  'appPerm.addDev': 'Thêm Dev',
  'appPerm.remove': 'Xóa',
  'appPerm.noProducts': 'Không có sản phẩm Long nào đang hoạt động.',
};
